module.exports = __webpack_public_path__ + "img/grey_032.80eaf61d.png";